import { useState, useEffect } from "react";
import { handleVideoTimeline } from "redux-share/actions";
import { useAppDispatch } from "redux-share/hooks";
import { setShowContinuousePlayback } from "redux-share/slices/userSlice";
import store from "redux-share/store";

const useContinuousePlaybackTimer = () => {
    const [timer, setTimer] = useState<number>(5);

    const dispatch = useAppDispatch();

    useEffect(() => {
        let interval: any = undefined;
        interval = setInterval(() => {
            setTimer((prev: number) => {
                if (prev === 0) {
                    const { videoSettings } = store.getState().user;
                    dispatch(setShowContinuousePlayback(false));
                    handleVideoTimeline(videoSettings.time);
                    clearInterval(interval);
                    return 0;
                } else return prev - 1;
            });
        }, 1000);

        () => clearInterval(interval);
    }, []);

    return timer;
};

export default useContinuousePlaybackTimer;
